import { FC } from 'react';
import Grid from '@mui/material/Grid';
import methodImg from '../../media/method.png';
import { Box, Typography, useMediaQuery } from '@mui/material';
import useTranslations from '../global/translation/hooks/translation';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';
import { designTokens } from '../../theme/designTokens';

const Method: FC = () => {
  const { currentLanguage, translations } = useTranslations();
  const theme = useTheme();
  const { darkMode } = useThemeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const palette = darkMode ? designTokens.colors.dark : designTokens.colors.light;

  const text = translations.label.methodText[currentLanguage];
  const paragraphs = text.split('\n\n');

  return (
    <Grid
      container
      justifyContent="center"
      sx={{
        bgcolor: darkMode ? palette.background.default : 'transparent',
        py: isMobile ? 6 : 10,
        px: isMobile ? 2 : 4,
      }}
    >
      {/* Header */}
      <Grid item xs={12} mb={6}>
        <Typography
          variant="h4"
          fontWeight={300}
          sx={{
            color: darkMode ? '#FFFFFF' : palette.primary,
            textAlign: 'center',
            letterSpacing: '-0.5px',
          }}
        >
          {translations.menuItems.method[currentLanguage]}
        </Typography>
      </Grid>

      {/* Content */}
      <Grid container spacing={isMobile ? 4 : 6} sx={{ maxWidth: '1200px', mx: 'auto' }}>
        <Grid item xs={12} md={6}>
          <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            {paragraphs.map((paragraph, idx) => (
              <Typography
                key={idx}
                variant="body2"
                sx={{
                  color: darkMode ? '#CCCCCC' : '#555555',
                  lineHeight: 1.7,
                  mb: idx < paragraphs.length - 1 ? 3 : 0,
                  fontSize: '15px',
                }}
              >
                {paragraph.trim()}
              </Typography>
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
            {/* Corner accent */}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '40px',
                height: '40px',
                borderTop: `3px solid ${theme.palette.primary.main}`,
                borderRight: `3px solid ${theme.palette.primary.main}`,
                borderRadius: '0 8px 0 0',
                zIndex: 2,
              }}
            />
            <Box
              sx={{
                width: '100%',
                paddingTop: '100%',
                position: 'relative',
                borderRadius: '50%',
                overflow: 'hidden',
              }}
            >
              <img
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
                src={methodImg}
                alt="Training methodology"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Method;
